import { Navigate } from "react-router-dom";

/** Legacy /account/referrals → Direct Team */
const AccountReferrals = () => <Navigate to="/account/team/direct" replace />;

export default AccountReferrals;
